import React, { useEffect, useState } from "react";
import { PiXFill } from "react-icons/pi";
import { getApi } from "../../../services/api/globalApi";
import { loanCalculation } from "../../../utils/calculations/loanCalculation";

const { forwardRef, useRef, useImperativeHandle } = React;

const GetLoanModal = forwardRef(({ installmentAmount }, ref) => {
  const [showModal, setShowModal] = useState(false);
  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {},
  }));

  const [month, setMonth] = useState([
    10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
  ]);

  const [loanData, setLoanData] = useState([]);

  const getCurrentLoanPrice = async (params) => {
    const path = "loansFormula/new";
    try {
      const response = await getApi({ path, params: { ...params } });
      console.log(response?.data?.data);
      setLoanData(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  console.log(installmentAmount);

  useEffect(() => {
    getCurrentLoanPrice();
  }, []);

  const [loans, setLoans] = useState([]);

  useEffect(() => {
    if (installmentAmount && loanData) {
      setLoans([]);
      const values = {
        money: installmentAmount,
      };
      setLoans(loanCalculation({ values, month, loan: loanData, type: "all" }));
    }
  }, [installmentAmount, loanData]);

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-[1500]  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[320px] sm:w-[800px] py-4 max-h-[360px] overflow-y-scroll bg-white mt-4 shadow-md z-[1501] rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-160px] sm:mr-[-400px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2">
          <h4>وام هایی که کاربر میتواند بگیرد</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>

        <div className="my-8">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    تعداد ماه
                  </th>
                  <th scope="col" className="px-6 py-3">
                    مبلغ قسط
                  </th>
                  <th scope="col" className="px-6 py-3">
                    مبلغ کل وام
                  </th>
                  <th scope="col" className="px-6 py-3">
                    میزان امتیاز 12 ماهه مورد نیاز
                  </th>
                  <th scope="col" className="px-6 py-3">
                    مقدار سفته مورد نیاز
                  </th>
                  <th scope="col" className="px-6 py-3">
                    هزینه نقدی پیشنهادی سایت
                  </th>
                  <th scope="col" className="px-6 py-3">
                    هزینه چکی پیشنهادی سایت
                  </th>
                </tr>
              </thead>
              <tbody>
                {loans?.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className="bg-white/50 border-b dark:bg-black/50 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                    >
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                      >
                        {item?.month} ماه
                      </th>
                      <td className="px-6 py-4 text-gray-800 dark:text-white">
                        {item?.amountOfInstallment}
                      </td>
                      <td className="px-6 py-4 text-gray-800 dark:text-white">
                        {item?.totalAmountOfLoan}
                      </td>
                      <td className="px-6 py-4 text-gray-800 dark:text-white">
                        {item?.promissoryNote}
                      </td>
                      <td className="px-6 py-4 text-gray-800 dark:text-white">
                        {item?.rewardRatesRequired}
                      </td>
                      <td className="px-6 py-4 text-gray-800 dark:text-white text-right">
                        {item?.SuggestedCashCost}
                      </td>
                      <td className="px-6 py-4 text-gray-800 dark:text-white text-right">
                        {item?.SuggestedChequeCost}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
});
export default GetLoanModal;
